/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { RibbonContribution } from '@ecsper/speciality-contract';

import { insertCprDeclaration, insertStatementOfTruth } from './commands.js';

/**
 * Stage 6 stub action factory. Returns a RibbonContribution
 * whose `action` shows a toast and does nothing else.
 * The shell wires the toast (taskPane has ToastProvider).
 */
function stage6Stub(
  id: string,
  label: string,
  iconId: string,
  featureName: string,
): RibbonContribution {
  return {
    id,
    label: { 'en-GB': label },
    tooltip: { 'en-GB': `${featureName} (Coming in Stage 6)` },
    iconId,
    group: 'stage-6-preview',
    action: async () => {
      // Shell may intercept stage-6-preview group commands and surface a toast.
    },
  };
}

export const expertWitnessWordRibbon: readonly RibbonContribution[] = [
  {
    id: 'ew.insert-sot',
    label: { 'en-GB': 'Statement of Truth' },
    tooltip: { 'en-GB': 'Insert the CPR Part 35.10(3) Statement of Truth' },
    iconId: 'shield-check',
    group: 'compliance',
    action: async () => {
      await insertStatementOfTruth();
    },
  },
  {
    id: 'ew.insert-declaration',
    label: { 'en-GB': 'CPR 35 Declaration' },
    tooltip: { 'en-GB': 'Insert the CPR Part 35.3 expert declaration' },
    iconId: 'scale',
    group: 'compliance',
    action: async () => {
      await insertCprDeclaration();
    },
  },
  stage6Stub('ew.stub.citation', 'Citation', 'quote', 'Citation insertion'),
  stage6Stub('ew.stub.vault-ref', 'Vault Ref', 'link', 'Vault reference insertion'),
  stage6Stub('ew.stub.ai-assist', 'AI Assist', 'sparkles', 'AI assistance'),
  stage6Stub('ew.stub.compliance', 'Compliance', 'clipboard-check', 'Compliance check'),
] as const;
